// extracted by mini-css-extract-plugin
export default {"cardOffer":"AddProduct_cardOffer__ATViT","btnOffer":"AddProduct_btnOffer__tvNXx"};